import {UserRepository} from '../repository/UserRepository';
import {RemoveRoleRequest, DashboardUser} from '../models/user.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class RemoveRoleUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (roleData: RemoveRoleRequest): Promise<DashboardUser> {
    // Validate required fields
    if (!roleData.userId || roleData.userId < 1) {
      throw new AppError('Valid user ID is required', ErrorType.VALIDATION);
    }

    if (!roleData.roleId || roleData.roleId < 1) {
      throw new AppError('Valid role ID is required', ErrorType.VALIDATION);
    }

    try {
      // Remove the role from the user
      const updatedUser = await this.userRepository.removeRole(roleData);

      return updatedUser;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
